module.exports = __webpack_public_path__ + "media/images/pepsi-south-ef9c5bfab44ecb1c78dbebd9e35bfc5f.png";